import { DarkModeIcon, IconButton, LightModeIcon } from '@/ui'
import { useTheme } from '@/lib/theme.js'

/**
 * A theme toggle button that cycles: light → dark → system → light.
 * Shows an icon representing the CURRENT mode and cycles on click.
 */
export function ThemeToggle() {
  const { theme, setTheme, isDark } = useTheme()

  const handleClick = () => {
    if (theme === 'light') {
      setTheme('dark')
    } else if (theme === 'dark') {
      setTheme('system')
    } else {
      setTheme('light')
    }
  }

  // Show appropriate icon and label for the current mode.
  const icon = isDark ? <LightModeIcon /> : <DarkModeIcon />
  const label = theme.charAt(0).toUpperCase() + theme.slice(1)

  return (
    <IconButton
      icon={icon}
      label={`Theme: ${label}. Click to cycle.`}
      onClick={handleClick}
      variant="standard"
    />
  )
}
